module.exports = __webpack_public_path__ + "static/media/sodimac.b4b40777.webp";